const getUrlRegex = (name) => {
	return new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
};

const getHashbangRegex = (name) => {
	return new RegExp(`(#!)(.*)(&?)${name}(=([^&#?]*)|&|#|$)`);
};

const getCurrentLowerCaseUrl = () => window.location.href.toLowerCase();

const getCurrentUrl = () => window.location.href;

class UrlHelper {
	static findParams(paramName, url, getRegex, getUrl) {
		let modifiedUrl = null;
		if (!url) {
			modifiedUrl = getUrl();
		} else {
			modifiedUrl = url;
		}
		const name = paramName.replace(/[[\]]/g, "\\$&").toLowerCase();
		const regex = getRegex(name);
		return regex.exec(modifiedUrl);
	}

	static getParameterByName(name, url) {
		const results = UrlHelper.findParams(
			name,
			url,
			getUrlRegex,
			getCurrentLowerCaseUrl
		);
		if (!results) return null;
		if (!results[2]) return "";
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

	static getHashBangParameterByName(name, url) {
		const results = UrlHelper.findParams(
			name,
			url,
			getHashbangRegex,
			getCurrentLowerCaseUrl
		);
		if (!results) return null;
		if (!results[5]) return "";
		return decodeURIComponent(results[5]);
	}

	static getParameterByNameCaseSensitive(name, url) {
		const results = UrlHelper.findParams(name, url, getUrlRegex, getCurrentUrl);
		if (!results) return null;
		if (!results[2]) return "";
		return results[2];
	}

	static redirect(url, parent) {
		if (url) {
			if (parent) {
				Isell.Bus.publish("ISellRedirect", url, parent);
			} else {
				window.location.href = url;
			}
		}
	}
}

export default UrlHelper;
